import React from "react";

export default function PRKpiBar({ summary = {} }) {

  const cards = [
    { label: "Total", value: summary.total || 0 },
    { label: "Draft", value: summary.draft || 0 },
    { label: "Submitted", value: summary.submitted || 0 },
    { label: "Approved", value: summary.approved || 0 },
    { label: "Closed", value: summary.closed || 0 }
  ];

  return (
    <div className="pr-kpi-bar">

      {cards.map((c) => (
        <div key={c.label} className="pr-kpi-card">
          <div className="pr-kpi-value">
            {c.value}
          </div>

          <div className="pr-kpi-label">
            {c.label}
          </div>
        </div>
      ))}

    </div>
  );
}
